import {combineReducers} from '@modifi/redux'

import entityReducer from './entity'

export default combineReducers({
  entity: entityReducer,
})
